import { useState } from "react";
import { Link } from "react-router-dom";

export function EuroClubs({ comp, clubs }) {
  const [q, setQ] = useState("");
  const list = clubs.filter((c) => `${c.name} ${c.city} ${c.country}`.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <section data-testid="europe-clubs">
      <label className="ncs-search">Search team <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Team, city or country" data-testid="europe-clubs-search" /></label>
      <div className="eu-clubs">
        {list.map((c) => (
          <Link key={c.code} to={`/europe/${comp}/teams/${c.code}`} className="eu-club" data-testid={`europe-club-${c.code}`}>
            {c.crest ? <img src={c.crest} alt="" loading="lazy" /> : <span className="ncs-logo-fallback">{c.tv}</span>}
            <span><strong>{c.name}</strong><small>{[c.city && c.city[0] + c.city.slice(1).toLowerCase(), c.country].filter(Boolean).join(", ")}</small></span>
          </Link>
        ))}
      </div>
      {!list.length && <p className="ncs-state">No matching teams.</p>}
    </section>
  );
}
